import { useEffect, useState } from "react";
import { IOptions } from "../Input-v2";

interface IuseGenerateOptions {
  dataSource?: any[];
  keyForText: string;
  keyForValue: string;
}

interface IuseGenerateArrayFromObj {
  dataSource?: Object;
}

const useGenerateArrayFromObj = ({ dataSource }: IuseGenerateArrayFromObj) => {
  const [result, setResult] = useState<IOptions[]>([]);

  useEffect(() => {
    if (dataSource && result.length <= 0) {
      const temp: IOptions[] = [];
      Object.entries(dataSource).map((item) => {
        temp.push({
          text: item[0],
          value: item[1],
        });
      });
      setResult(temp);
    }
  }, [dataSource]);

  return { data: result };
};

const useGenerateOptions = ({
  dataSource,
  keyForText,
  keyForValue,
}: IuseGenerateOptions) => {
  const [dataOptions, setDataOptions] = useState<IOptions[]>([]);

  useEffect(() => {
    if (dataSource) {
      const temp: IOptions[] = [];
      dataSource.forEach((item) => {
        temp.push({
          text: item[keyForText],
          value: item[keyForValue],
        });
      });
      setDataOptions(temp);
    }
  }, [dataSource]);

  return { data: dataOptions };
};

export { useGenerateArrayFromObj };

export default useGenerateOptions;
